import * as React from 'react';
import { IOptionInterface } from 'src/components/MultiSelectFilter/IOptionInterface';
import styled from 'styled-components';

const CheckBoxWrapper = styled.div`
  width: 100%;
  padding-bottom: 1em;
  font-size: 14px;
`;

export class MultiSelectFilterOption extends React.Component<IOptionInterface> {
  public render() {
    return (
      <CheckBoxWrapper data-tip={this.props.helpText} data-for="filteroptiontooltip">
        <label>
          <input type="checkbox" checked={this.props.selected} onChange={this.props.onClick} />
          {this.props.label}
        </label>
      </CheckBoxWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MultiSelectFilter/MultiSelectFilterOption.tsx